import { createContext } from "react";

const AdContext = createContext();

export default AdContext;
